// ============================================================================
// DINIC - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'dinic',
  name: 'Dinic',
  category: 'Graphs',
  complexity: {
    time: 'O(V²E)',
    space: 'O(V²)'
  },
  description: 'An efficient algorithm for computing maximum flow in a network. It uses BFS to construct level graphs and DFS to send blocking flows, achieving better performance than Edmonds-Karp for dense graphs.'
};
